// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"90a37ed4","455":"4563864a","644":"8e1013b6"}[chunkId] + ".chunk.js";
};